/* global IntersectionObserver */

import React, { useEffect } from 'react';
import { useClassifiedOfferDataLayerPush } from '../../../domain/offer/analytics/ClassifiedOfferGtmContext';
import { ClassifiedAnalytics } from '../../../domain/offer/analytics/ClassifiedAnalytics';

type IPropsUseOfferViewAnalytics = {
    hasHighlightPriority?: boolean;
    hasTop?: boolean;
    hasAnyPriority?: boolean;
    isSaleOffer?: boolean;
    isNewBuilding: boolean;
    offerId: string;
    organizationName?: string;
    offerRef: React.RefObject<HTMLDivElement>;
    onVisible?(): void;
}

export const useOfferViewAnalytics = ({
    hasHighlightPriority,
    isNewBuilding,
    offerId,
    organizationName,
    offerRef,
    isSaleOffer,
    hasTop,
    hasAnyPriority,
    onVisible
}: IPropsUseOfferViewAnalytics) => {
    const dataLayerPush = useClassifiedOfferDataLayerPush();

    useEffect(() => {
        const options = {
            rootMargin: '0px',
            threshold: 0
        };

        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    onVisible?.();
                    if (! isNewBuilding) {
                        if (hasHighlightPriority || hasTop || hasAnyPriority) {
                            if (hasHighlightPriority) {
                                dataLayerPush({
                                    offerId,
                                    organizationName,
                                    event: isSaleOffer ?
                                        ClassifiedAnalytics.SearchSaleViewHighlightOffer :
                                        ClassifiedAnalytics.SearchRentViewHighlightOffer
                                });
                            }

                            if (hasTop || hasAnyPriority) {
                                dataLayerPush({
                                    offerId,
                                    organizationName,
                                    event: isSaleOffer ?
                                        ClassifiedAnalytics.SearchSaleViewPaidOffer :
                                        ClassifiedAnalytics.SearchRentViewPaidOffer
                                });
                            }
                        } else {
                            dataLayerPush({
                                offerId,
                                organizationName,
                                event: isSaleOffer ?
                                    ClassifiedAnalytics.SearchSaleViewOffer :
                                    ClassifiedAnalytics.SearchRentViewOffer
                            });
                        }
                    }

                    if (offerRef?.current) {
                        observer.disconnect();
                    }
                }
            });
        }, options);

        if (offerRef.current) {
            observer.observe(offerRef.current);
        }
        return () => {
            observer.disconnect();
        };
    }, [ hasAnyPriority, offerId, hasHighlightPriority, dataLayerPush, onVisible ]);
};
